function encode(value) {
  return encodeURIComponent(value);
}

function decode(value) {
  return decodeURIComponent(value.replace(/\+/g, " "));
}

function shouldSerializeAsJson(value) {
  if (!value || typeof value !== "object") return false;
  if (!Array.isArray(value)) return true;
  return value.some((item) => item && typeof item === "object");
}

function parseQueryValue(value) {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  if (!trimmed || (trimmed[0] !== "{" && trimmed[0] !== "[")) return value;

  try {
    return JSON.parse(trimmed);
  } catch (e) {
    return value;
  }
}

function stringifyQuery(query) {
  const pairs = [];

  Object.keys(query || {}).forEach((key) => {
    const value = query[key];
    if (typeof value === "undefined") return;

    const encodedKey = encode(key);
    if (value === null) {
      pairs.push(encodedKey);
      return;
    }

    if (Array.isArray(value) && !shouldSerializeAsJson(value)) {
      value.forEach((item) => {
        if (typeof item === "undefined") return;
        if (item === null) {
          pairs.push(encodedKey);
        } else {
          pairs.push(`${encodedKey}=${encode(String(item))}`);
        }
      });
      return;
    }

    const normalized = shouldSerializeAsJson(value) ? JSON.stringify(value) : String(value);
    pairs.push(`${encodedKey}=${encode(normalized)}`);
  });

  return pairs.length ? `?${pairs.join("&")}` : "";
}

function parseQuery(query) {
  const res = {};
  const normalizedQuery = (query || "").trim().replace(/^(\?|#|&)/, "");
  if (!normalizedQuery) return res;

  normalizedQuery.split("&").forEach((param) => {
    const parts = param.replace(/\+/g, " ").split("=");
    const key = decode(parts.shift());
    const rawValue = parts.length > 0 ? parts.join("=") : null;
    const value = rawValue === null ? null : parseQueryValue(decode(rawValue));

    if (typeof res[key] === "undefined") {
      res[key] = value;
    } else if (Array.isArray(res[key])) {
      res[key].push(value);
    } else {
      res[key] = [res[key], value];
    }
  });

  return res;
}

module.exports = {
  parseQuery,
  stringifyQuery,
};
